// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"37":"Homepage","74":"About","121":"Home Layout"}[chunkId] || chunkId) + "." + {"37":"1354a200","74":"dbd98160","121":"1d971cd4","366":"2338a887"}[chunkId] + ".js";
};